// extracted by mini-css-extract-plugin
module.exports = {"container":"CartNotFound_container__2DPdE","content":"CartNotFound_content__1ZdBp","redirect":"CartNotFound_redirect__2k-IK","icon":"CartNotFound_icon__1tapR"};